import DeformationFieldOverlay from './Deformation/DeformationFieldOverlay';
import DeformationHeatmapOverlay from './Deformation/DeformationHeatmapOverlay';
import DeformationUncertaintyOverlay from './Deformation/DeformationUncertaintyOverlay';
import type { Environment } from '~/engine/data/Environment';
import { RenderAdapter } from '~/viewportGrid/adapters/types';
import { usePlaneViewHostedBy } from '../usePlaneViewHostedBy';

interface TileDeformationMountProps {
    renderer: RenderAdapter;
    // The Environment of the image in the field's fixed frame; the overlays draw on its panes only.
    fieldHost: Environment | undefined;
}

export default function TileDeformationMount({
    renderer,
    fieldHost,
}: TileDeformationMountProps) {
    const view = usePlaneViewHostedBy(renderer, fieldHost);
    if (!view) {
        return null;
    }
    return (
        <>
            <DeformationUncertaintyOverlay view={view} />
            <DeformationHeatmapOverlay view={view} />
            <DeformationFieldOverlay view={view} />
        </>
    );
}
